import * as React from 'react'

const TwitterLogoCircle: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width={35} height={35} viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.125.5c-9.387 0-17 7.613-17 17s7.613 17 17 17 17-7.613 17-17-7.613-17-17-17Zm7.762 13.255c.008.167.011.335.011.504 0 5.156-3.925 11.102-11.102 11.102-2.204 0-4.254-.646-5.98-1.753.304.036.615.054.93.054a7.83 7.83 0 0 0 4.846-1.67 3.906 3.906 0 0 1-3.645-2.71 3.88 3.88 0 0 0 1.762-.067 3.903 3.903 0 0 1-3.13-3.825v-.05a3.874 3.874 0 0 0 1.768.488A3.898 3.898 0 0 1 8.61 12.58c0-.715.193-1.384.529-1.961a11.078 11.078 0 0 0 8.043 4.077 3.903 3.903 0 0 1 6.65-3.558 7.829 7.829 0 0 0 2.476-.948 3.917 3.917 0 0 1-1.715 2.159 7.784 7.784 0 0 0 2.24-.615 7.93 7.93 0 0 1-1.946 2.02Z"
      fill="currentColor"
    />
  </svg>
)

export default TwitterLogoCircle
